import AuthLayout from "@/layouts/AuthLayout.vue";
import BackOfficeLayout from "@/layouts/BackOfficeLayout.vue";
import Dashboard from "@/core/Pages/Dashboard.vue";
import Account from "@/modules/Authentication/Pages/Account.vue";
import SignatoryList from "@/modules/Authentication/Pages/SignatoryList.vue";
import AccountDelete from "@/modules/Authentication/Pages/AccountDelete.vue";
import AccountEditPassword from "@/modules/Authentication/Pages/AccountEditPassword.vue";
import OrganizationDashboard from "@/core/Pages/OrganizationDashboard.vue";
import { AuthenticationRoutes } from "@/modules/Authentication/Routes";
import folderRoutes from "@/modules/Folder/Routes";
import adminRoutes from "@/modules/Admin/Routes";
import campaignRoutes from "@/modules/Campaign/Routes";
import clientRoutes from "@/modules/Client/Routes";
import SimpleLayout from "@/layouts/SimpleLayout.vue";
import ClientFullData from "@/modules/ClientFullData/Routes";
import ImpersonaRoutes from "@/modules/Impersona/Routes";
import SpaceManagerRoutes from "@/modules/SpaceManager/Routes";

export const routes = [
  {
    path: "/auth",
    component: AuthLayout,
    children: [...AuthenticationRoutes],
  },
  {
    path: "/organization/:organizationId",
    name: "organization",
    component: BackOfficeLayout,
    meta: {
      authenticationRequired: true,
    },
    props: true,
    children: [
      {
        path: "dashboard/",
        name: "ORGANIZATION_DASHBOARD",
        component: OrganizationDashboard,
        props: true,
        meta: {
          authenticationRequired: true,
          breadcrumbs: [
            {
              name: "ORGANIZATION_DASHBOARD",
              disabled: true,
              label: "utils.dashboard",
            },
          ],
        },
      },
      ...folderRoutes,
      ...adminRoutes,
      ...campaignRoutes,
      ...clientRoutes,
    ],
  },
  {
    path: "/dashboard",
    component: BackOfficeLayout,
    meta: {
      authenticationRequired: true,
    },
    children: [
      {
        path: "",
        name: "dashboard",
        component: Dashboard,
        meta: {
          authenticationRequired: true,
        },
      },
    ],
  },
  {
    path: "/profile",
    component: BackOfficeLayout,
    meta: {
      authenticationRequired: true,
    },
    children: [
      {
        path: "settings/",
        name: "account",
        component: Account,
        props: true,
        meta: {
          authenticationRequired: true,
        },
      },
      {
        path: "signatory/",
        name: "SignatoryList",
        component: SignatoryList,
        props: true,
        meta: {
          authenticationRequired: true,
        },
      },
      {
        path: "change-password/",
        name: "accountEditPassword",
        component: AccountEditPassword,
        props: true,
      },
      {
        path: "delete-account/",
        name: "accountDelete",
        component: AccountDelete,
        props: true,
      },
    ],
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/",
    component: SimpleLayout,
    children: [...ClientFullData, ...ImpersonaRoutes, ...SpaceManagerRoutes],
  },
  {
    path: "*",
    redirect: "/dashboard",
  },
];
